import { render, staticRenderFns } from "./DreceiptView.vue?vue&type=template&id=1cb8f5e8&scoped=true"
import script from "./DreceiptView.vue?vue&type=script&lang=js"
export * from "./DreceiptView.vue?vue&type=script&lang=js"
import style0 from "./DreceiptView.vue?vue&type=style&index=0&id=1cb8f5e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb8f5e8",
  null
  
)

export default component.exports